import React from 'react'
import { SelectMonth } from '../selects/SelectMonth'

interface ISelectMonthProps {
    
    field: { name: string; value: any; onChange: () => void }
    form: {
        setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
    }
    className: string
    startMonth: Date
    endMonth: Date
    disabled: boolean
    defaultValue?:string
    onSelectedChange?: (val: any) => void
}

export const FormSelectMonth: React.FC<ISelectMonthProps> = (props) => {
    return (
        <>
            <SelectMonth
                handleChange={(e) => {                
                    props.form.setFieldValue(props.field.name, new Date(e.target.value))
                    props.onSelectedChange?.(e)
                }}
                defaultValue={props.defaultValue}
                value={props.field.value}
                startMonth={props.startMonth}
                endMonth={props.endMonth}
                disabled={props.disabled}
            />
        </>
    )
}
